<template>
<v-container class="fill-height data-container" fluid>

    <div id="ag-grid-container">
        <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
            :gridOptions="gridOptions"
            @row-double-clicked="(params) => $emit('edit', params.data)"
            :groupHeaders="true"
            :rowHeight="40">
        </ag-grid-vue>
    </div>

</v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
export default {
  name: 'UserThresholdList',
  props: ['userThresholdList', 'thresholdResources', 'editChange', 'lockSave'],
  components: {
    'ag-grid-vue': AgGridVue,
  },
  data: () => ({
      showGrid: false,
      gridOptions: null,
  }),

  computed: {
    
  },

  methods: {
    buildAgGrid: function() {
        this.showGrid = false;
        this.gridOptions = {};
        this.gridOptions.rowData = this.$props.userThresholdList;
        this.gridOptions.columnDefs = this.createColumnDefs();
        let self = this;
        this.gridOptions.onGridReady = function(params) {
            self.gridOptions.api.hideOverlay();
            self.gridOptions.api.sizeColumnsToFit();
        }

        this.gridOptions.getContextMenuItems = function() {
            return [
                'copy',
                'copyWithHeaders',
                'paste',
                'csvExport',
                'excelExport',
                {
                    name: 'AI Analyser',
                    disabled: !self.$store.state.batchConfig.webapp_openai,
                    action: function() {
                        self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                        self.$store.commit('setShowAIAnalyzer', true);
                    },
                    icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                },
            ];
        };

        this.gridOptions.defaultColDef = {
            sortable: true,
            filter: true,
            resizable: true
        }
        this.showGrid = true;
    },

    createColumnDefs: function() {
        let columnDefs = [];
        const self = this;
        columnDefs = [
            { 
                headerName: '', 
                suppressSizeToFit: true,
                width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                cellRenderer: class {
                    init(params) {
                        this.params = params;
                        this.eGui = document.createElement('div');
                        this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle user-tres-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                            <span class="mdi mdi-delete-circle user-tres-action" style="cursor: ${self.$props.lockSave ? 'default' : 'pointer'}; color: ${self.$props.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                        
                        this.editButtonHandler = this.editButtonHandler.bind(this);
                        this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                        this.editButton = this.eGui.querySelectorAll('.user-tres-action')[0];
                        this.deleteButton = this.eGui.querySelectorAll('.user-tres-action')[1];
                        this.editButton.addEventListener('click', this.editButtonHandler);
                        this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                    }
                    getGui() {
                        return this.eGui;
                    }
                    editButtonHandler(event) {
                        event.stopPropagation();
                        this.params.editFunction(this.params);
                    }
                    deleteButtonHandler(event) {
                        event.stopPropagation();
                        this.params.deleteFunction(this.params);
                    }
                    destroy() {
                        this.editButton.removeEventListener('click', this.editButtonHandler);
                        this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                    }
                },
                cellRendererParams: {
                    editFunction: (params) => {self.$emit('edit', params.data);},
                    deleteFunction: (params) => {
                        if(!self.$props.lockSave) {
                            self.$emit('delete', params.data.thres_id);
                        }
                    }
                }
            },
            { 
                headerName: 'Name', 
                field: 'thres_name', 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Report', 
                valueGetter: function(params){return params.data.thres_obj ? params.data.thres_obj.name : ""}, 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Format', 
                valueGetter: function(params){return self.$props.thresholdResources.formats[params.data.thres_method]}, 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Metric',
                valueGetter: function(params){return params.data.thres_obj ? params.data.thres_obj.columns[params.data.thres_column] : ""}, 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Threshold',
                valueGetter: function(params) {
                    const thresMethod = (params.data.thres_method === 1) ? self.$props.thresholdResources.methods[params.data.thres_method_column] : 'Metric'
                    return `${thresMethod} ${self.$props.thresholdResources.conditions[params.data.thres_test]} ${params.data.thres_value}`;
                }, 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Criteria',
                valueGetter: function(params) {
                    let criteriaAnswer = "";
                    for(const criteriaString of params.data.thres_criteria) {
                        const criteriaArray = criteriaString.split(' ');
                        criteriaAnswer += `${params.data.thres_obj.columns[criteriaArray[0]]} `;
                        criteriaAnswer += `${self.$props.thresholdResources.conditions[criteriaArray[1]]} `;
                        criteriaAnswer += `${criteriaArray[2]}; `;
                    }
                    return criteriaAnswer;
                },
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Sort Metric', 
                valueGetter: function(params) {
                    if(params.data.thres_method === 1) {
                        return (params.data.thres_sort_col < 0) ? 'default' : self.$props.thresholdResources.methods[params.data.thres_sort_col]
                    }
                    else {
                        return (params.data.thres_sort_col < 0) ? 'default' : params.data.thres_obj.columns[params.data.thres_sort_col]
                    }
                },
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Sort Order', 
                valueGetter: function(params){return self.$props.thresholdResources.orders[params.data.thres_sort_order]}, 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Row Limit', 
                valueGetter: function(params){return self.$props.thresholdResources.limits[params.data.thres_row_limit]}, 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Parameters', 
                valueGetter: function(params){return params.data.thres_human_params.join(',')}, 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
            { 
                headerName: 'Filter', 
                valueGetter: function(params){return params.data.thres_filter.split('|').join(';')}, 
                width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
            },
        ];
        return columnDefs;
    },

  },

  watch: {
    userThresholdList(newVal, oldVal) {
      if(!this.$props.lockSave) {
        this.$store.commit('setIsDirty', true);
      }
      this.gridOptions.api.setRowData(this.$props.userThresholdList);
    },

    editChange(newVal, oldVal) {
      if(!this.$props.lockSave) {
        this.$store.commit('setIsDirty', true);
      }
      this.gridOptions.api.refreshCells();
    },
  },

  mounted() {
    this.buildAgGrid();
  }

  
};
</script>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
        width: 100%;
    }

</style>
